import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { JiraProductDiscoveryLogo } from "@atlaskit/logo";
import { Text } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";
import { JiraBackground } from "@atlassian/product-wireframes";

import { Modal } from "@/components/signup/layouts/modal";
import {
    UfoCustomTimingKey,
    UfoCustomTimingWrapper,
    ufoEventRedirectToProduct
} from "@/components/signup/utils";
import { ProvisioningStatus } from "@/libraries/bxp-web-stargate-client/src";

import { ProvisioningProgressBar } from "../../sections/provisioning-progress-bar";

import { JPDProvisioningHeroSvg } from "./components/jira-product-discovery-provisioning-hero-svg";

const heroImageContainer = css({
    marginBlockStart: token("space.250"),
    marginBlockEnd: token("space.500")
});

const progressBarTextContainer = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
});

const contentContainer = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginBlockStart: token("space.500"),
    marginBlockEnd: token("space.1000")
});

export interface JiraProductDiscoveryProvisioningScreenProps {
    provisioningStep?: string;
    provisioningStatus?: ProvisioningStatus;
}

export const JiraProductDiscoveryProvisioningScreen = ({
    provisioningStep,
    provisioningStatus
}: JiraProductDiscoveryProvisioningScreenProps = {}) => (
    <div>
        <UfoCustomTimingWrapper
            ufoEvent={ufoEventRedirectToProduct}
            ufoCustomTimingKey={
                UfoCustomTimingKey.JIRA_PRODUCT_DISCOVERY_ONBOARDING_SPINNER_DWELL_TIME
            }
        >
            <JiraBackground>
                <Modal size="lg" showBrandFooter={false}>
                    <div css={contentContainer}>
                        <JiraProductDiscoveryLogo
                            appearance="brand"
                            size="medium"
                        />
                        <div css={heroImageContainer}>
                            <JPDProvisioningHeroSvg />
                        </div>
                        <div css={progressBarTextContainer}>
                            <ProvisioningProgressBar
                                provisioningStep={provisioningStep}
                                provisioningStatus={provisioningStatus}
                            />
                            <Text variant="body">
                                <FormattedMessage
                                    id="SignupProvisioning.inProgressText.jiraProductDiscovery.waitingForProvisioning"
                                    defaultMessage="Adding Jira Product Discovery. Less than two minutes remaining..."
                                />
                            </Text>
                        </div>
                    </div>
                </Modal>
            </JiraBackground>
        </UfoCustomTimingWrapper>
    </div>
);
